.InlineLink {
  position: relative;
  text-decoration: underline;
  text-decoration-color: var(--brand-InlineLink-color-rest);
  text-decoration-thickness: var(--brand-borderWidth-thin);
  text-underline-position: under;
  transition: var(--brand-InlineLink-transition-timing) text-decoration;
}

.InlineLink:hover {
  text-decoration-thickness: var(--brand-borderWidth-thick);
}

.InlineLink,
.InlineLink > span {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: var(--brand-InlineLink-color-rest);
}

.InlineLink:active,
.InlineLink:active > span {
  color: var(--brand-InlineLink-color-pressed);
}

[data-color-mode='dark'] .InlineLink {
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
}

@media (prefers-color-scheme: dark) {
  [data-color-mode='auto'] .InlineLink {
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: auto;
  }
}

/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  .InlineLink,
  .InlineLink::before,
  .InlineLink::after,
  .InlineLink * {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
